import Resource from './Resource';
import SimpleResource from './SimpleResource';
export * from './types';
export * from './normal';

const SuperagentResource = Resource;

export { Resource, SimpleResource, SuperagentResource };
